if (!customElements.get('video-overlay')) {
  customElements.define(
    'video-overlay',
    class VideoOverlay extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // 初始化
        // 获取button video-close-button
        this.videoSrc = this.getAttribute('data-video-src');

        this.video = this.querySelector('iframe');
        this.closeButton = this.querySelector('.video-close-button [aria-controls="VideoOverlay"]');
        this.closeButton.addEventListener('click', this.close.bind(this));
        this.overlay = this.querySelector('.fixed-overlay');
        this.overlay.addEventListener('click', this.close.bind(this));

        this.spinner = this.querySelector('.loading__spinner');
        

        //监听data-open属性变化
        this.addEventListener('data-open', this.onDataOpenChange.bind(this));

        // 监听iframe加载完成事件
        this.video.addEventListener('load', () => {
          this.setSpinnerVisible(false);
        });
        
      }

      static get observedAttributes() {
        return ['data-open'];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-open') {
          if (oldValue === newValue) {
            return;
          }
          if (newValue === 'true') {
            this.onOpen();
          } else {
            this.onClose();
          }
        }
      }

      onDataOpenChange() {
        debugger;
        if (this.getAttribute('data-open') === 'true') {
          this.onOpen();
        } else {
          this.onClose();
        }
      }

      onClose() {
        // 关闭视频
        if (this.video) {
          this.video.src = '';
        }
        if (this.overlay) {
          this.overlay.setAttribute('aria-expanded', 'false');
        }
        if (this.closeButton) {
          this.closeButton.setAttribute('aria-expanded', 'false');
        }
      }

      onOpen() {
        this.overlay.setAttribute('aria-expanded', 'true');
        this.closeButton.setAttribute('aria-expanded', 'true');
        // 显示加载 spinner
        this.setSpinnerVisible(true);
        // 打开视频
        if (this.videoSrc) {
          this.video.src = this.videoSrc;
        }  
      }

      open() {
        this.setAttribute('data-open', 'true');
      }

      close() {
        this.setAttribute('data-open', 'false');
      }

      setVideoSrc(src) {
        this.setAttribute('data-video-src', src);
        this.videoSrc = src;
      }

      setSpinnerVisible(visible) {
        if (visible) {
          this.spinner.classList.remove('hidden');
        } else {
          this.spinner.classList.add('hidden');
        }
      }

      
    }
  );
}
